export function ToInt16(num:number) {
    const result = num > 32767 ? -(65536 - num) : num;
    return result;
}